import React from 'react';
// import Loading from "../Loading";
import "./Overload.css";

function OverLoad() {
  return (
    <div className='overload-overlay' style={{
      display:"flex",
      justifyContent:"center"
    }}>
        <div className='overload'>
        <div class="spinner">
    <div class="lds1-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>

    <div>Loading...</div>
</div>
        </div>
    </div>
  )
}

export default OverLoad
